import { FC } from 'react';
import HeroGridCard from '../HeroGridCard';
import cards from './cards';
import styles from './HeroGrid.module.scss';

const HeroGrid: FC = () => (
  <ul className={styles.root}>
    {cards.map((card) => <HeroGridCard key={card.id} {...card} />)}
  </ul>
);

export default HeroGrid;
